// A zero-price `.free` claim's checkout response carries its activation code/link directly,
// but the full-page redirect to the success page loses any in-memory state — stash them here,
// keyed by the claim token the redirect carries, for the success page to read back.
const STORAGE_KEY_PREFIX = 'externalSalesClaimArtifacts:';

export type ClaimArtifacts = {
  code: string | null;
  link: string | null;
};

export function persistClaimArtifacts(token: string, artifacts: ClaimArtifacts): void {
  try {
    window.sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${token}`, JSON.stringify(artifacts));
  } catch {
    // Storage can throw (private mode, quota, disabled); the read side already treats a missing value as normal.
  }
}

export function readPersistedClaimArtifacts(token: string): ClaimArtifacts | null {
  try {
    const raw = window.sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${token}`);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
